var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, StyledEngineProvider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { usePopover } from '../hooks';
import { NotificationPanel } from './notification-panel';
import { TotIconButton } from './tot-icon-button';
export var iconStyle = {
    fontSize: '24px',
};
var sx = {
    badge: {
        '& [class*=MuiBadge-badge]': {
            color: function (theme) { return theme.palette.common.white; },
        },
    },
};
export var NotificationWidget = function (props) {
    var _a = usePopover(), anchorEl = _a.anchorEl, setPopoverClose = _a.setPopoverClose, setPopoverOpen = _a.setPopoverOpen, isOpen = _a.isOpen;
    var loadCountNotViewedMessages = props.loadCountNotViewedMessages, userId = props.userId;
    var _b = useState(0), notViewedNotifications = _b[0], setNotViewedNotifications = _b[1];
    useEffect(function () {
        loadCountNotViewedMessages().then(setNotViewedNotifications);
    }, [loadCountNotViewedMessages, setNotViewedNotifications, userId]);
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(TotIconButton, { color: "secondary", onClick: setPopoverOpen, id: "bell-icon", size: "large" },
            React.createElement(Badge, { color: "error", badgeContent: notViewedNotifications || undefined, sx: sx.badge },
                React.createElement(NotificationsIcon, { sx: iconStyle }))),
        React.createElement(NotificationPanel, __assign({ isOpen: isOpen, anchorEl: anchorEl, setPopoverClose: setPopoverClose, setNotViewedNotifications: setNotViewedNotifications, notViewedNotifications: notViewedNotifications }, props))));
};
